<template>
  <div class="bb-payroll">
    <div class="bb-popup-export-excel">
      <i class="icon-menu bb-popup-export-excel__icon" @click.stop="popupExport = true"/>
      <transition name="bounce">
        <div class="bb-popup-export-excel-popup"
             @click.stop="openExport()"
             v-if="popupExport"
             v-click-outside="hidePopupExport">
          <span class="bb-popup-export-excel-popup__text">Export to Excel</span>
        </div>
      </transition>
    </div>
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <div class="bb-payroll-balance">
      <Table :options="options" :totalPages="fullPayrolls.totalPages" :multiple="true" :min-width="1200"/>
      <button class="bb-button-dashed" @click.stop="newPayroll()">
        <i class="icon-cross"/>
        Add new
      </button>
      <Pagination :data="fullPayrolls" :getQuery="getPayroll" :limit="defLimit" class="bb-pagination"/>
    </div>
    <transition name="fade" mode="out-in">
      <ExportExcel :columns="columnsData"
                   v-if="openSettingExport"
                   :data="dataForExport"
                   file-name="payroll"
                   :generateExcel="generateExcel"
                   @close="hideSettingExport"/>
    </transition>
  </div>
</template>

<script>
import Table from '@/components/Main/Table/Table'
import TotalCard from '@/components/Finance/InvoiceTable/TotalCard/TotalCard'
import {payrollTable, payrollTableColumns} from '@/constants/TablesOptions/payrollTable'
import UsersListApi from '@/api/UsersList/api'
import PayrollApi from '@/api/Payroll/api'
import UploadFileApi from '@/api/UploadFile/api'
import _ from 'lodash'
import ExpensesCategoryApi from '@/api/ExpenseCategories/api'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import Pagination from '@/components/Main/Pagination/Pagination'
import moment from 'moment'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import FundsApi from '@/api/Funds/api'
import ExportExcel from '@/components/Main/ExportExcel/ExportExcel'
import b64toBlob from 'b64-to-blob'
import {saveAs} from 'file-saver'

export default {
  name: 'Payroll',
  components: {
    ModalWindow,
    Table,
    TotalCard,
    Pagination,
    LoaderFly,
    ExportExcel
  },
  data () {
    return {
      popupExport: false,
      openSettingExport: false,
      dataForExport: {},
      newFiles: [],
      loaderRun: false,
      filterByDate: this.defaultRangeDate,
      fullPayrolls: '',
      defLimit: 50,
      file: '',
      openForm: false,
      options: payrollTable,
      filterByKey: [],
      fullFilter: false,
      uploadsFiles: [],
      crypt: true,
      files: {}
    }
  },
  computed: {
    defaultRangeDate () {
      const start = moment().subtract(10, 'years').format('YYYY-MM-DD')
      const end = moment().format('YYYY-MM-DD')
      return `dateOfPayment=${start};;${end}`
    },
    expenseCategories: {
      get: function () {
        return this.$store.getters.expenseCategories
      },
      set: function (data) {
        this.$store.dispatch('setExpensesCategories', data)
      }
    },
    users: {
      get: function () {
        return this.$store.getters.usersList
      },
      set: function (data) {
        this.$store.dispatch('setUsersList', data)
      }
    },
    columnsData () {
      return this.payrollColumnsData.filter(item => item.title)
    },
    payrollColumnsData: {
      get: function () {
        return this.$store.getters.payrollColumnsData
      },
      set: function (data) {
        this.$store.dispatch('setPayrollColumnsData', data)
      }
    },
    payrollRowsData: {
      get: function () {
        return this.$store.getters.payrollRowsData
      },
      set: function (data) {
        this.$store.dispatch('setPayrollRowsData', data)
      }
    },
    fundsRowsData: {
      get: function () {
        return this.$store.getters.fundsRowsData
      },
      set: function (data) {
        this.$store.dispatch('setFundsRowsData', data)
      }
    }
  },
  methods: {
    async generateExcel (data) {
      const resp = await PayrollApi.generateExcel(data)
      return resp
    },
    hideSettingExport () {
      this.hidePopupExport()
      this.openSettingExport = false
    },
    openExport () {
      this.openSettingExport = true
      this.dataForExport = {
        query: this.fullFilter
      }
    },
    hidePopupExport () {
      this.popupExport = false
    },
    closeForm () {
      this.openForm = false
    },
    getUserName (data) {
      const res = _.cloneDeep(data)
      const id = data.employeeName
      const user = _.find(this.users, {id: id})
      if (!user) {
        res.employeeName = ''
      } else {
        user.name = user.username
        res.employeeName = user || ''
      }

      const idExpenses = data.modeOfPayment
      const expenses = _.find(this.expenseCategories, {id: idExpenses})
      res.modeOfPayment = expenses || ''

      const idFund = data.funds
      const fund = _.find(this.fundsRowsData, {id: idFund})
      res.funds = fund || ''
      return res
    },
    newPayroll () {
      const payroll = {
        amountAED: 0,
        dateOfPayment: new Date(),
        newMode: true,
        create: this.createPayroll,
        description: {
          start: new Date(),
          end: new Date()
        }
      }
      const newHave = _.find(this.payrollRowsData, {newMode: true})
      if (newHave) {
        return
      }
      this.payrollRowsData.unshift(payroll)
    },
    addActions () {
      _.forEach(this.payrollColumnsData, item => {
        if (item.actions) {
          item.actions.delete = this.deletePayroll
          item.actions.edit = this.editPayroll
          item.actions.getFile = this.openFile
          item.actions.uploadFile = this.uploadAllFiles
          item.actions.deleteFile = this.deleteFile
          item.actions.filter = this.setFilter
        }
      })
    },
    setFilter (data, item, property) {
      if (data) {
        const res = {
          query: `&${property}[]=${item.id}`,
          id: item.id
        }
        this.filterByKey.push(res)
      } else {
        const index = _.findIndex(this.filterByKey, {id: item.id})
        this.filterByKey.splice(index, 1)
      }
      this.getPayroll({limit: this.defLimit})
    },
    getFunds () {
      FundsApi.getFunds({limit: 100})
        .then((resp) => {
          this.fundsRowsData = resp.data.fundUsersListApis
          this.payrollColumnsData.forEach(item => {
            if (item.listName === 'fundList') {
              item.list = _.sortBy(resp.data.funds, ['name'])
            }
          })
          this.getPayroll({})
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getExpensesCategories () {
      ExpensesCategoryApi.getExpenseCategories()
        .then((resp) => {
          this.expenseCategories = resp.data.expensesCategories
          this.payrollColumnsData.forEach(item => {
            if (item.listName === 'expensesCategories') {
              const typeOfPayment = _.filter(this.expenseCategories, {type: 3})
              item.list = _.sortBy(typeOfPayment, ['name'])
            }
          })
          this.getFunds()
        })
        .catch((err) => {
          console.error(err)
        })
    },
    setTypeOfPaymentList () {
      const list = _.sortBy([
        {name: 'Salary', id: 'Salary'},
        {name: 'Bonus', id: 'Bonus'},
        {name: 'KPI', id: 'KPI'},
        {name: 'Unused Vacation', id: 'Unused Vacation'},
        {name: 'Advanced Salary', id: 'Advanced Salary'}
      ], ['name'])
      this.payrollColumnsData.forEach(item => {
        if (item.listName === 'typeOfPaymentList') {
          item.list = list
        }
      })
    },
    setUserList () {
      this.payrollColumnsData.forEach(item => {
        if (item.listName === 'usersList') {
          item.list = _.sortBy(this.users, ['username'])
        }
      })
    },
    getUserList () {
      this.loaderRun = true
      UsersListApi.getUsersList({limit: 1000})
        .then((resp) => {
          this.users = _.filter(resp.data.users, item => item)
          this.setTypeOfPaymentList()
          this.setUserList()
          this.getExpensesCategories()
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    createFilterQuery (filter) {
      let fullQuery = ''
      if (this.filterByKey.length === 0) return filter
      this.filterByKey.forEach(item => {
        fullQuery += item.query
      })
      return filter + fullQuery
    },
    getPayroll ({limit = this.defLimit, page, filter}) {
      if (this.users.length === 0 || this.expenseCategories === 0) return
      this.loaderRun = true
      if (filter) {
        this.filterByDate = `dateOfPayment=${filter}`
      }
      if (!filter && !this.filterByDate) {
        this.filterByDate = this.defaultRangeDate
      }
      const fullFilter = this.createFilterQuery(this.filterByDate)
      this.fullFilter = fullFilter
      this.getPayrollTotal({query: this.fullFilter})
      PayrollApi.getPayroll({query: this.fullFilter, limit, page})
        .then((resp) => {
          this.fullPayrolls = resp.data
          const result = []
          resp.data.salaries.forEach(item => {
            result.push(this.getUserName(item))
          })
          this.payrollRowsData = result
          this.addActions()
          this.loaderRun = false
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    setFileData (file) {
      const fileData = new FormData()
      fileData.set('fieldname', 'uploadFile')
      fileData.set('label', file.name || '')
      fileData.set('file', file)
      return fileData
    },
    createPayroll (payroll) {
      payroll.uploadFile = this.uploadsFiles.map(item => item.id)
      PayrollApi.createPayroll(payroll)
        .then((resp) => {
          resp.data.uploadFile = this.uploadsFiles
          this.payrollRowsData.unshift(this.getUserName(resp.data))
          this.getPayrollTotal({query: this.filterByDate})
          this.uploadsFiles = []
        })
        .catch((err) => {
          console.error(err)
        })
    },
    editPayroll (payroll) {
      const oldFiles = _.filter(payroll.uploadFile, item => item.path || item.id).map(item => item.id)
      const newFiles = this.uploadsFiles.map(item => item.id)
      payroll.uploadFile = _.uniq(newFiles.concat(oldFiles))
      if (!payroll.funds) delete payroll.funds
      const index = _.findIndex(this.payrollRowsData, {id: payroll.id})
      PayrollApi.editPayroll(payroll)
        .then((resp) => {
          this.payrollRowsData.splice(index, 1, this.getUserName(resp.data))
          if (payroll.originmodeOfPayment) {
            this.payrollRowsData[index].modeOfPayment = payroll.originmodeOfPayment
          }
          this.getPayrollTotal({query: this.filterByDate})
          this.uploadsFiles = []
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getPayrollTotal ({query}) {
      PayrollApi.getPayrollTotal({query})
        .then((resp) => {
          this.$emit('setTotal', resp.data.totalAmount)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    deletePayroll (id) {
      const index = _.findIndex(this.payrollRowsData, {id: id})
      PayrollApi.deletePayroll(id)
        .then((resp) => {
          this.payrollRowsData.splice(index, 1)
          this.getPayrollTotal({query: this.filterByDate})
        })
        .catch((err) => {
          console.error(err)
        })
    },
    uploadAllFiles (files, row, rows, copyRow) {
      this.newFiles = []
      _.forEach(files, file => {
        this.uploadFile(this.setFileData(file), row, rows, copyRow)
      })
    },
    uploadFile (fileData, row, rows, copyRow) {
      const index = _.findIndex(rows, {id: row.id})
      UploadFileApi.createFile(fileData, this.crypt)
        .then((resp) => {
          this.newFiles.push(resp.data)
          this.uploadsFiles.push(resp.data)
          row = _.cloneDeep(copyRow)
          const oldFile = row.uploadFile || []
          row.uploadFile = _.uniq(oldFile.concat(this.newFiles))
          if (index !== -1) {
            rows.splice(index, 1, row)
          } else if (row.newMode) {
            rows.splice(0, 1, row)
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    openFile (file) {
      this.files[file.id] ? saveAs(this.files[file.id].blob, this.files[file.id].label) : this.getFile(file)
    },
    getFile (file) {
      this.loaderRun = true
      UploadFileApi.getFile(file.id, this.crypt)
        .then((resp) => {
          this.openForm = true
          const blob = b64toBlob(resp.data.base64, resp.data.type)
          this.files[resp.data.id] = {id: resp.data.id, blob, label: resp.data.label}
          saveAs(blob, resp.data.label)
          this.loaderRun = false
        })
        .catch((err) => {
          console.error(err)
          this.loaderRun = false
        })
    },
    deleteFile (id, row, rows, copyRow) {
      const index = _.findIndex(rows, {id: row.id})
      UploadFileApi.deleteFile(id, this.crypt)
        .then((resp) => {
          row = _.cloneDeep(copyRow)
          const oldFile = row.uploadFile || []
          const indexFile = _.findIndex(oldFile, {id: id})
          if (indexFile !== -1) oldFile.splice(indexFile, 1)
          if (index !== -1) {
            rows.splice(index, 1, row)
          } else if (row.newMode) {
            rows.splice(0, 1, row)
          }
        })
        .catch((err) => {
          console.error(err)
        })
    }
  },
  beforeMount () {
    this.$emit('setQuery', this.getPayroll)
    this.payrollColumnsData = payrollTableColumns
    this.getUserList()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bb-payroll {
    @include global-font;
    position: relative;

    &-balance {
      &__document {
        width: 70vw;
        height: 74vh;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Finance/Expenses/Payroll/Payroll.vue